import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import ProgressIndicatorIcon from 'assets/icons/ic-progress-indicator.svg';
import ProgressDoneIcon from 'assets/icons/ic-progress-done.svg';
import ProgressUndoneIcon from 'assets/icons/ic-progress-undone.svg';
import React from 'react';

interface WizardProgressProps {
  step: number;
}

export const WizardProgress = ({ step }: WizardProgressProps) => {
  const isFirstStep = step === 1;
  const ICON_SIZE = 24;

  return (
    <FlexColumn>
      <FlexRow justify={'space-between'}>
        <BodyText size={2} style={{ color: isFirstStep ? '#0021A5' : '#D2D3D9' }}>
          Details
        </BodyText>
        <BodyText size={2} style={{ color: isFirstStep ? '#D2D3D9' : '#0021A5' }}>
          Integration
        </BodyText>
      </FlexRow>
      <FlexRow
        justify="space-between"
        style={{ position: 'relative', alignItems: 'center', width: '100%', marginTop: 8 }}
      >
        {/* connector line */}
        <div
          aria-hidden
          style={{
            position: 'absolute',
            top: '50%',
            left: ICON_SIZE, // start from the left icon
            right: ICON_SIZE, // end to the right icon
            height: 2,
            transform: 'translateY(-50%)',
            zIndex: 0,
            backgroundImage: isFirstStep
              ? 'linear-gradient(to right, #0021A5 0, #0021A5 50%, #D2D3D9 50%, #D2D3D9 100%)'
              : 'linear-gradient(to right, #0021A5 0, #0021A5 100%)'
          }}
        />

        {/* icons sit above the line */}
        <FlexRow style={{ zIndex: 1 }}>
          <SvgIcon src={isFirstStep ? ProgressIndicatorIcon : ProgressDoneIcon} size={ICON_SIZE} />
        </FlexRow>
        <FlexRow style={{ zIndex: 1 }}>
          <SvgIcon
            src={isFirstStep ? ProgressUndoneIcon : ProgressIndicatorIcon}
            size={ICON_SIZE}
          />
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
};
